import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useEmergencyCreditsConfig() {
  const emergencyCreditsConfig = useCbhFlag(CbhFeatureFlag.EMERGENCY_CREDITS_CONFIG, {
    defaultValue: { enabled: false },
  });

  return emergencyCreditsConfig;
}
